import React, { useCallback, useMemo, useRef } from "react";
import ReportsDashboard from "../../components/reports/ReportsDashboard";
import { useV2Theme } from "../theme/ThemeProvider";

const V2ReportsPage = () => {
  const { tokens } = useV2Theme();

  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  }, []);

  // The create-report logic lives in ReportsDashboard; it registers its
  // handler here so the button can live in this page's panel header
  // instead of taking a row of its own inside the dashboard.
  const newReportActionRef = useRef(null);
  const registerNewReportAction = useCallback((fn) => {
    newReportActionRef.current = fn;
  }, []);

  return (
    <section className="space-y-4">
      <div className="text-xs text-slate-500">
        <span>Workspace</span>
        <span className="mx-2 text-slate-300">/</span>
        <span className="text-slate-700">Reports</span>
      </div>

      <div className={tokens.surface.card}>
        <div
          className={`${tokens.surface.panelHeader} flex flex-wrap items-center gap-3`}
        >
          <div className="min-w-0">
            <h2 className="text-base font-semibold text-slate-900">Reports</h2>
            <p className="text-xs text-slate-500 mt-1">
              Create, manage, and share custom reports for your enterprise architecture.
            </p>
          </div>
          <button
            type="button"
            onClick={() => newReportActionRef.current?.()}
            className="ml-auto inline-flex shrink-0 items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
          >
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            New Report
          </button>
        </div>
        <div className="border-t border-slate-200 v2-explorer-light">
          <ReportsDashboard
            user={user}
            embedded
            registerNewReportAction={registerNewReportAction}
          />
        </div>
      </div>
    </section>
  );
};

export default V2ReportsPage;
